import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DeviceActivity, DeviceElement, DeviceElementResponse } from './../models/device.model';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';

const API_URL = environment.API_URL

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor(private http: HttpClient) { }

  getAllDevices(company_id: number): Observable<DeviceElement[]> {
    return this.http.get<DeviceElement[]>(`${API_URL}/companies/${company_id}/devices`);
  }

  getDeviceById(id: number, company_id: number): Observable<DeviceElementResponse> {
    return this.http.get<DeviceElementResponse>(`${API_URL}/companies/${company_id}/devices/${id}`);
  }

  getDeviceBySn(serial_number: string): Observable<DeviceElementResponse> {
    return this.http.get<DeviceElementResponse>(`${API_URL}/devices/${serial_number}`);
  }

  addDevice(device: DeviceElement, company_id: number): Observable<any> {
    return this.http.post<any>(`${API_URL}/companies/${company_id}/devices`, device);
  }

  updateDevice(id: number, device: DeviceElement, company_id: number): Observable<any> {
    return this.http.put<any>(`${API_URL}/companies/${company_id}/devices/${id}`, device);
  }

  getDeviceActivity(id: number, company_id: number): Observable<{ data: DeviceActivity[] }> {
    return this.http.get<{ data: DeviceActivity[] }>(`${API_URL}/companies/${company_id}/devices/${id}/activity`);
  }

  deleteDevice(id: number, company_id: number): Observable<any> {
    return this.http.delete<any>(`${API_URL}/companies/${company_id}/devices/${id}`);
  }

  // ── Notification emails ───────────────────────────────────────────────────

  getNotificationEmails(deviceId: number, companyId: number): Observable<any> {
    return this.http.get(`${API_URL}/companies/${companyId}/devices/${deviceId}/notification-emails`);
  }

  addNotificationEmail(deviceId: number, companyId: number, email: string, label?: string): Observable<any> {
    return this.http.post(`${API_URL}/companies/${companyId}/devices/${deviceId}/notification-emails`, { email, label: label || null });
  }

  deleteNotificationEmail(deviceId: number, companyId: number, id: number): Observable<any> {
    return this.http.delete(`${API_URL}/companies/${companyId}/devices/${deviceId}/notification-emails/${id}`);
  }

  // ── Notification contacts ─────────────────────────────────────────────────

  getNotificationContacts(deviceId: number, companyId: number): Observable<any> {
    return this.http.get(`${API_URL}/companies/${companyId}/devices/${deviceId}/notification-contacts`);
  }

  addNotificationContact(deviceId: number, companyId: number, userId: number): Observable<any> {
    return this.http.post(`${API_URL}/companies/${companyId}/devices/${deviceId}/notification-contacts`, { user_id: userId });
  }

  deleteNotificationContact(deviceId: number, companyId: number, id: number): Observable<any> {
    return this.http.delete(`${API_URL}/companies/${companyId}/devices/${deviceId}/notification-contacts/${id}`);
  }

}
